function whichTransitionEvent() {
    var el = document.createElement('fakeelement');
    var transitions = {
        OTransition: 'oTransitionEnd',
        WebkitTransition: 'webkitTransitionEnd'
    };
    for (var t in transitions) {
        /* istanbul ignore next */
        if (el.style[t] !== undefined) {
            /* istanbul ignore next */
            return transitions[t];
        }
    }
    return 'transitionend';
}
var transitionEvent = whichTransitionEvent();
var ToProgress = /** @class */ (function () {
    function ToProgress(opts) {
        this.options = {
            id: 'toprogress',
            color: '#F44336',
            height: '2px',
            duration: 0.2,
            position: 'top',
            selector: 'body'
        };
        this.element = document.createElement('div');
        this.progress = 0;
        Object.assign(this.options, opts || {});
        this.element.id = this.options.id;
        this.setCSS();
        this.setTransition(this.options.duration);
        this.createProgressBar();
    }
    /**
     * Note, because .start() uses a single CSS transition, this will not
     * accurately reflect the position on the screen
     * @returns Current progress
     */
    ToProgress.prototype.getProgress = function () {
        return this.progress;
    };
    /**
     * @param progress 0-100
     * @returns Promise which resolves after transition animation completes
     */
    ToProgress.prototype.setProgress = function (progress) {
        this.progress = Math.min(100, Math.max(0, progress));
        this.element.style.width = this.progress + '%';
        return this.transitionEnd('width');
    };
    /**
     * @param duration Max amount of time to animate. Larger values = slower moving bar.
     * @param easing CSS transition easing
     * @returns Promise which resolves after timeout or `.finish()`
     */
    ToProgress.prototype.start = function (duration, easing) {
        if (duration === void 0) { duration = 30; }
        if (easing === void 0) { easing = 'cubic-bezier(0.05, 0.45, 0.05, 0.95)'; }
        this.show();
        this.setTransition(duration, easing);
        /**
         * Need to ensure that if already started the width is changed so
         * that the new transition takes effect.
         */
        return this.setProgress(this.progress === 99 ? 98 : 99);
    };
    ToProgress.prototype.stop = function () {
        this.setTransition(10e10);
        this.setProgress(this.progress - 1).catch(function () { });
    };
    /**
     * @param i Amount to increment progress
     * @returns Promise which resolves after animation completes
     */
    ToProgress.prototype.increase = function (i) {
        return this.setProgress(this.progress + i);
    };
    /**
     * @param i Amount to decrement progress
     * @returns Promise which resolves after animation completes
     */
    ToProgress.prototype.decrease = function (i) {
        return this.setProgress(this.progress - i);
    };
    ToProgress.prototype.hide = function () {
        this.element.style.opacity = '0';
    };
    ToProgress.prototype.show = function () {
        this.element.style.opacity = '1';
    };
    /**
     * Transition to 100%, hide, and reset
     *
     * @returns Promise which resolves after progress bar has been reset
     */
    ToProgress.prototype.finish = function () {
        var _this = this;
        this.setTransition(this.options.duration);
        this.setProgress(100).catch(function () { });
        this.hide();
        return this.transitionEnd('opacity').then(function () { return _this.reset(); });
    };
    /**
     * Set progress to 0 and show after transition completes
     *
     * @returns Promise which resolves after progress bar has been reset
     */
    ToProgress.prototype.reset = function () {
        var _this = this;
        this.setTransition(this.options.duration);
        return this.setProgress(0).then(function () { return _this.show(); });
    };
    ToProgress.prototype.destroy = function () {
        this.element.remove();
    };
    ToProgress.prototype.setCSS = function () {
        var _this = this;
        var styles = {
            'position': this.options.selector === 'body' ? 'fixed' : 'absolute',
            'top': this.options.position === 'top' ? '0' : 'auto',
            'bottom': this.options.position === 'bottom' ? '0' : 'auto',
            'left': '0',
            'right': '0',
            'background-color': this.options.color,
            'height': this.options.height,
            'width': '0%',
            'opacity': '1',
            'box-shadow': "0px 1px 2px 0px " + this.options.color
        };
        Object.keys(styles).forEach(function (style) { return _this.element.style[style] = styles[style]; });
    };
    ToProgress.prototype.setTransition = function (duration, easing) {
        var _this = this;
        if (easing === void 0) { easing = 'ease-out'; }
        var opacityDuration = Math.min(duration * 3, 1);
        var rule = "width " + duration + "s " + easing + ", opacity " + opacityDuration + "s";
        var styles = {
            'transition': rule,
            '-moz-transition': rule,
            '-webkit-transition': rule
        };
        Object.keys(styles).forEach(function (style) { return _this.element.style[style] = styles[style]; });
    };
    ToProgress.prototype.createProgressBar = function () {
        var el = document.querySelector(this.options.selector);
        if (!el) {
            throw new Error("[toprogress2] Element not found with selector " + this.options.selector);
        }
        if (el.hasChildNodes()) {
            el.insertBefore(this.element, el.firstChild);
        }
        else {
            el.appendChild(this.element);
        }
    };
    ToProgress.prototype.transitionEnd = function (property) {
        var _this = this;
        return new Promise(function (resolve) {
            var onTransitionEnd = function (e) {
                if (e.propertyName === property) {
                    resolve();
                    _this.element.removeEventListener(transitionEvent, onTransitionEnd);
                }
            };
            _this.element.addEventListener(transitionEvent, onTransitionEnd);
        });
    };
    return ToProgress;
}());
export { ToProgress };



//////////////////
// WEBPACK FOOTER
// ./node_modules/toprogress2/dist/es/index.js
// module id = iVGB
// module chunks = 0